import { render, staticRenderFns } from "./fast_index.vue?vue&type=template&id=64f8b6c4&scoped=true&"
import script from "./fast_index.vue?vue&type=script&lang=js&"
export * from "./fast_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8b6c4",
  null
  
)

export default component.exports